module.exports = __webpack_public_path__ + "static/media/cpp.1f5f8c45.svg";